import { navigate } from "gatsby-plugin-intl"
import paths from "utils/paths"

export const isEmptyRedirect = (component, redirectTo = paths.notFound) => {
  if (!component || Object.keys(component).length === 0) {
    navigate(`${redirectTo}`)
  }
}
